import React, { useEffect } from 'react';
import { useState } from 'react';
import { Card, Row, Col, Form, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../UI/button';
import { sendForgotPasswordLink } from '../../services/authentication.service';
import { ResetPasswordProps } from '../types/reset-password-props';
import withAlert from '../../HOCs/withAlert';

function ForgotPasswordEmail({
  error = '',
  setError,
  message = '',
  setMessage
}: ResetPasswordProps) {
  const [email, setEmail] = useState('');
  const [sendButtonName, setSendButtonName] = useState('Send Reset Email');
  const [validated, setValidated] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;
    if (email && form.checkValidity() === true) {
      try {
        //email exists, send reset link
        const success = await sendForgotPasswordLink(email);
        setMessage('Password reset link sent successfully.');
      } catch (error) {
        //error sending reset link
        setError(
          'Unable to send a password reset link.  Please check email address and try again.'
        );
      }
      setSendButtonName('Resend Reset Email');
    } else {
      //email does not exist
      setError('Please enter a valid email address.');
    }
    setValidated(true);
  };

  // const validateEmail = (email: string) => {
  //   const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   return re.test(String(email).toLowerCase());
  // };

  return (
    <div className='login w-100'>
      <Row className='g-0 justify-content-md-center'>
        <Col
          md='6'
          className='bg-border-color-gray position-relative'
        >
          <Card.Img
            src='https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/img1.webp'
            alt='login form'
            className='w-100 h-100 object-fit-cover position-absolute'
            style={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0
            }}
          />
        </Col>
        <Col
          md='6'
          className='d-flex align-items-center justify-content-center position-relative overflow-hidden min-vh-100'
        >
          <div
            className='gradient-bg-login'
            style={{ left: '0' }}
          ></div>
          <div
            style={{
              maxWidth: '440px',
              width: '100%',
              padding: '3rem 20px 5rem'
            }}
          >
            <div className='d-flex flex-column'>
              <div className='d-flex flex-column text-center'>
                <span className='h1 fw-bold'>
                  Travel
                  <span className='text-primary'>Hearts</span>
                </span>
                <h3 className='fw-bold'>Forgot Password</h3>
              </div>

              <h5
                className='fw-normal font-libre fs-6 mx-auto text-center text-capitalize text-dark-2'
                style={{
                  letterSpacing: '1px',
                  marginTop: '12px',
                  marginBottom: '32px',
                  lineHeight: '150%'
                }}
              >
                reset password link will be sent to your registered email
              </h5>
              {message && <Alert variant='success'>{message}</Alert>}
              {error && <Alert variant='danger'>{error}</Alert>}

              <Form
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
              >
                <Form.Group
                  style={{ marginBottom: '20px' }}
                  controlId='usernameInput'
                >
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type='email'
                    placeholder='Enter here'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>
                <Button
                  type='submit'
                  className='font-libre'
                  width='full'
                  color='dark'
                  size='md'
                  fontSize='sm'
                  fontFamily='libre'
                >
                  {sendButtonName}
                </Button>
              </Form>
              <p
                style={{ margin: '24px 0 20px' }}
                className='pb-lg-2 fs-7 text-center'
              >
                Already reset password?{' '}
                <a
                  href='/login'
                  className='text-primary fw-bold font-libre'
                >
                  Login
                </a>
              </p>
            </div>
          </div>
          <p
            className='position-absolute position-x-center font-libre fs-7 fw-bold text-dark-2'
            style={{ bottom: '32px' }}
          >
            © Travel Hearts 2024
          </p>
        </Col>
      </Row>
    </div>
  );
}

export default withAlert(ForgotPasswordEmail);
